"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = assert;
// the base assert module doesn't use ts assertion syntax
function assert(value, message) {
    if (value == null) {
        throw new Error(message);
    }
}
//# sourceMappingURL=assert.js.map